<div class="v1-view" *ngIf="!showAiFieldHistoryView">
  <div class="field-history-view__header flex items-center justify-between">
    <div class="flex items-center back-btn" (click)="onClickBack()">
      <i class="fa-solid fa-arrow-left"></i>&nbsp; Go Back
    </div>
    <div *ngIf="isAiFieldHistoryPending && !isAiResponseAvailable"
         class="field-history-view__ai-toggle-skeleton"
         role="status">
      <span class="field-history-view__ai-toggle-skeleton-shine" aria-hidden="true"></span>
      <span class="field-history-view__ai-toggle-skeleton-label">
        <i class="fa-regular fa-wand-magic-sparkles" aria-hidden="true"></i>
        Preparing AI Summary
      </span>
    </div>
    <button *ngIf="isAiResponseAvailable && fieldHistoryAiResponse"
            type="button"
            class="field-history-view__toggle field-history-view__toggle--ready"
            matTooltip="AI summary"
            aria-label="Open AI summary view"
            (click)="openAiFieldHistoryView()">
      <i class="fa-regular fa-wand-magic-sparkles" aria-hidden="true"></i>
    </button>
  </div>
  <div class="details-container" *ngIf="dataEditFieldDetails">
    <h5> Details</h5>
    <table class="data-table">
      <tbody>
        <tr *ngFor="let fieldDetail of dataEditFieldDetails?.fieldDetails">
          <td class="title"><span matTooltip="{{fieldDetail.title}}">{{fieldDetail.title}}:</span></td>
          <td *ngIf="fieldDetail.valueType === ValueType.Text">
            <span class="value" matTooltip="{{fieldDetail.value}}">{{fieldDetail.value}}</span>
          </td>
          <td *ngIf="fieldDetail.valueType === ValueType.Url">
            <particle-dynamic-tooltip-container
                                                [ngStyle]="{'cursor': (hasShareId || isMagicLinkUser) ? 'not-allowed' : 'pointer'}"[openOption]="'hover'"
                                                [position]="'left'"
                                                [htmlElement]="(isMagicLinkUser || hasShareId) ? disableBtnHoverMessage : fieldDetail.value"
                                                [theme]="'dark'">
              <span class="value">
              <a title="{{fieldDetail.value}}" [ngClass]="(hasShareId || isMagicLinkUser) ? 'disabled' : ''"
                 (click)="onNavigateToSource(dataEditFieldDetails.transportSummary)">
                {{fieldDetail.value}}
              </a>
            </span>
            </particle-dynamic-tooltip-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="history-container" *ngIf="dataEditFieldDetails">
    <h5>{{this.getHistoryDaysTitle()}}</h5>
    <ng-container *ngIf="!this.isLoading && dataEditFieldDetails.editHistories && dataEditFieldDetails.editHistories.length>0">
      <ul>
        <li *ngFor="let fieldEditHistory of dataEditFieldDetails.editHistories; let id = index;" [class]="id === 0? 'active': '' ">
          <div class="value-container">
            <div class="value">{{fieldEditHistory.currentValue}}</div>
            <ul class="informations">
              <li class="{{historyDetail.styleClass}}"  *ngFor="let historyDetail of fieldEditHistory.historyDetails">
                <i class="{{historyDetail.icon}}"></i>
                <particle-dynamic-tooltip-container *ngIf="historyDetail.valueType === ValueType.Url"
                                                  [ngStyle]="{'cursor': (hasShareId || isMagicLinkUser) ? 'not-allowed' : 'pointer'}"
                                                  [openOption]="'hover'"
                                                  [position]="'left'"
                                                  [htmlElement]="(isMagicLinkUser || hasShareId) ? disableBtnHoverMessage : historyDetail.value"
                                                  [theme]="'dark'">
                <a [ngClass]="(hasShareId || isMagicLinkUser) ? 'disabled' : ''"
                   (click)="onNavigateToSource(fieldEditHistory.dataTransportSummary)">
                    {{historyDetail.value}}
                  </a>
                </particle-dynamic-tooltip-container>
              <div *ngIf="!historyDetail.isUrl" matTooltip="{{historyDetail.title}}{{historyDetail.value}}">
                  <span>{{historyDetail.title}}</span>{{historyDetail.value}}
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <!-- <div *ngIf="this.isShowFullHistoryEnable()">
        <a class="link-color pointer m-t-5" (click)="this.showFullHistory()"><u>Show full history</u></a>
      </div> -->
    </ng-container>
    <div *ngIf="this.isLoading" class="loading-container">

      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <div class="m-t-15 label-no-history" *ngIf="!dataEditFieldDetails.editHistories || dataEditFieldDetails.editHistories.length === 0">
      No history available
    </div>
  </div>

  <div class="loading-container" *ngIf="!dataEditFieldDetails">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
  <div class="flex justify-center">
    <button mat-button (click)="onAddComment()" class="action-button" *ngIf="this.feedId && dataEditFieldDetails"> <i class="fa-light fa-message-lines"></i> Add a Comment</button>
  </div>
</div>

<div class="v2-view" *ngIf="showAiFieldHistoryView">
  <div class="field-history-view__header flex items-center justify-between">
    <div class="flex items-center back-btn" (click)="onClickBack()">
      <i class="fa-solid fa-arrow-left"></i>&nbsp; Go Back
    </div>
    <button *ngIf="isAiResponseAvailable && fieldHistoryAiResponse"
            type="button"
            class="field-history-view__toggle"
            matTooltip="Standard view"
            aria-label="Switch to standard field history view"
            (click)="closeAiFieldHistoryView()">
      <i class="fa-regular fa-table-list" aria-hidden="true"></i>
    </button>
  </div>

  <div class="v2-view__scroll">
  <div class="ai-field-stats">
    <div class="ai-field-stats__row">
      <span class="ai-field-stats__label">Current value</span>
      <span class="ai-field-stats__value">{{ fieldHistoryAiResponse.currentValue }}</span>
    </div>
    <div class="ai-field-stats__row" *ngIf="fieldHistoryAiResponse.totalEdits != null">
      <span class="ai-field-stats__label">Total edits</span>
      <span class="ai-field-stats__value">{{ fieldHistoryAiResponse.totalEdits }}</span>
    </div>
  </div>

  <div class="ai-insights" *ngIf="fieldHistoryAiResponse.insights?.length">
    <h5 class="ai-insights__title">Insights</h5>
    <ul class="ai-insights__list">
      <li *ngFor="let insight of fieldHistoryAiResponse.insights" class="ai-insights__item">{{ insight }}</li>
    </ul>
  </div>

  <div class="ai-timeline-card"
       [class.ai-timeline-card--has-entries]="sortedAiTimeline.length > 0"
       [class.ai-timeline-card--empty]="sortedAiTimeline.length === 0">
    <div class="ai-timeline-card__head">
      <h5 class="ai-timeline-card__title">Timeline</h5>
    </div>
    <div class="ai-timeline-card__body">
      <ul class="ai-timeline-card__list" *ngIf="sortedAiTimeline.length > 0">
        <li *ngFor="let entry of sortedAiTimeline; let i = index; let last = last"
            class="ai-timeline-card__item"
            [class.ai-timeline-card__item--last]="last">
          <button type="button"
                  class="ai-timeline-card__toggle"
                  (click)="toggleAiTimelineExpanded(i)"
                  [attr.aria-expanded]="isAiTimelineExpanded(i)">
            <span class="ai-timeline-card__action">{{ entry.action }}</span>
            <i class="fa-regular ai-timeline-card__chevron"
               [ngClass]="isAiTimelineExpanded(i) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <div class="ai-timeline-card__details" *ngIf="isAiTimelineExpanded(i)">
            <ul class="informations ai-timeline-card__meta">
              <li class="file-details" *ngIf="entry.date">
                <i class="fa-regular fa-calendar"></i>
                <div><span>Date: </span>{{ entry.date }}</div>
              </li>
              <li class="file-details" *ngIf="entry.actor">
                <i class="fa-regular fa-user"></i>
                <div><span>Actor: </span>{{ entry.actor }}</div>
              </li>
              <li class="file-details" *ngIf="entry.sourceSystem">
                <i class="fa-regular fa-folder"></i>
                <div><span>Source: </span>{{ entry.sourceSystem }}</div>
              </li>
              <li class="file-details file-details--value-change"
                  *ngIf="hasTimelineValueChange(entry)">
                <i class="fa-regular fa-right-left"></i>
                <div class="ai-timeline-card__value-change">
                  <span class="ai-timeline-card__value-from"
                        [class.ai-timeline-card__value-placeholder]="!hasTimelineSideValue(entry.valueBefore)">{{ getTimelineValueFromDisplay(entry) }}</span>
                  <span class="ai-timeline-card__value-arrow" aria-hidden="true">→</span>
                  <span class="ai-timeline-card__value-to"
                        [class.ai-timeline-card__value-placeholder]="!hasTimelineSideValue(entry.valueAfter)">{{ getTimelineValueToDisplay(entry) }}</span>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <div class="m-t-15 label-no-history" *ngIf="sortedAiTimeline.length === 0">
        No timeline entries
      </div>
    </div>
  </div>
  </div>

  <div class="flex justify-center v2-view__footer">
    <button mat-button (click)="onAddComment()" class="action-button" *ngIf="this.feedId && dataEditFieldDetails">
      <i class="fa-light fa-message-lines"></i> Add a Comment
    </button>
  </div>
</div>
